const StripeStatus = ({ status }) => {
    const statuses = [
      { name: "Won", img: "https://akm-img-a-in.tosshub.com/lingo/nwtak/resources/image-33_0.png", color: "bg-green-100" },
      { name: "Loss", img: "https://akm-img-a-in.tosshub.com/lingo/nwtak/resources/image-36.png", color: "bg-red-100" },
      { name: "Trailing", img: "https://akm-img-a-in.tosshub.com/lingo/nwtak/resources/image-34.png", color: "bg-yellow-100" },
      { name: "Leading", img: "https://akm-img-a-in.tosshub.com/lingo/nwtak/resources/image-35.png", color: "bg-blue-100" },
    ];
  
    return (
      <div className="flex  ">
        {statuses.map((status) => (
          <div key={status.name} className={`flex items-center space-x-2 p-2 rounded-lg  `}>          
            <img src={status.img} alt={status.name} className="w-5 h-5 mt-1" />
            <span className="font-medium">{status.name}</span>
          </div>
        ))}
      </div>
    );
  };
  
  export default StripeStatus;
  